'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringReplacer = void 0;
class StringReplacer {
    /**
     * Create a new string replacer instance.
     */
    constructor(Strings, searchValue) {
        this.strings = Strings;
        this.searchValue = searchValue;
        this.shouldReplaceAll = false;
        this.shouldReplaceLast = false;
    }
    /**
     * Replace all occurences of the search value.
     *
     * @returns {this}
     */
    all() {
        this.shouldReplaceAll = true;
        return this;
    }
    /**
     * Replace the last occurence of the search value.
     *
     * @returns {this}
     */
    last() {
        this.shouldReplaceLast = true;
        return this;
    }
    with(replacer) {
        switch (true) {
            case this.shouldReplaceAll:
                return this.strings.replaceAll(this.searchValue, replacer ?? '');
            case this.shouldReplaceLast:
                return this.strings.replaceLast(this.searchValue, replacer ?? '');
            default:
                return this.strings.replace(this.searchValue, replacer ?? '');
        }
    }
}
exports.StringReplacer = StringReplacer;
